export const getCustomSelectStyles = theme => ({
  menu: styles => ({
    ...styles,
    border: `1px solid ${theme.select.border}`,
    padding: 0,
    borderRadius: 0,
    zIndex: 1000,
    background: theme.select.background,
    minHeight: 62,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  }),
  menuList: styles => ({
    ...styles,
    padding: 0,
    width: '100%',
  }),
  valueContainer: styles => ({ ...styles, background: 'transparent', border: 'none', paddingLeft: 0 }),
  indicatorSeparator: styles => ({ ...styles, display: 'none' }),
  clearIndicator: styles => ({
    ...styles,
    color: theme.secondaryText,
    cursor: 'pointer',
    ':hover': {
      backgroundColor: 'transparent',
      color: theme.text,
    },
  }),
  multiValue: styles => ({ ...styles, background: 'none', border: `1px solid ${theme.text}` }),
  singleValue: styles => ({ ...styles, color: theme.text }),
  multiValueLabel: styles => ({ ...styles, color: theme.text }),
  input: styles => ({ ...styles, color: theme.text }),
  multiValueRemove: styles => ({
    ...styles,
    color: theme.secondaryText,
    cursor: 'pointer',
    ':hover': {
      backgroundColor: 'transparent',
      color: theme.text,
    },
  }),
  option: (styles, { isFocused, isDisabled }) => {
    return {
      ...styles,
      minHeight: 62,
      fontSize: 18,
      display: 'flex',
      alignItems: 'center',
      background: isFocused && !isDisabled ? theme.text : theme.select.background,
      color: isFocused && !isDisabled ? theme.background : theme.secondaryText,
      borderBottom: `1px solid ${theme.select.border}`,
      width: '100%',
      wordBreak: 'break-word',
      ':active': { background: theme.text },
    };
  },
  control: styles => ({
    ...styles,
    background: 'transparent',
    boxShadow: 'none',
    borderRadius: 0,
    border: 'none',
    borderBottom: `2px solid ${theme.border}`,
    ':hover': { border: 'none', borderBottom: `2px solid ${theme.secondaryText}` },
  }),
});
